"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var ngx_webcam_1 = require("ngx-webcam");
var sis_photo_capture_popup_component_1 = require("./controls/capture/sis-photo-capture-popup.component");
var sis_photo_capture_component_1 = require("./controls/capture/sis-photo-capture.component");
var sis_document_component_1 = require("./controls/document/sis-document.component");
var sis_download_component_1 = require("./controls/download/sis-download.component");
var sis_upload_2_component_1 = require("./controls/new-upload/sis-upload-2.component");
var sis_upload_component_1 = require("./controls/upload/sis-upload.component");
var material_module_1 = require("./material.module");
var pipe_module_1 = require("./pipes/pipe.module");
var DocumentControlsModule = /** @class */ (function () {
    function DocumentControlsModule() {
    }
    DocumentControlsModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                material_module_1.MaterialModule,
                idm_ng_controls_1.ControlsModule,
                pipe_module_1.PipeModule,
                ngx_webcam_1.WebcamModule
            ],
            declarations: [
                sis_upload_2_component_1.NewUpload,
                sis_download_component_1.Download,
                sis_document_component_1.DocumentComponent,
                sis_upload_component_1.Upload,
                sis_photo_capture_component_1.PhotoCaptureComponent,
                sis_photo_capture_popup_component_1.CapturePopup
            ],
            entryComponents: [sis_photo_capture_popup_component_1.CapturePopup],
            exports: [
                material_module_1.MaterialModule,
                sis_upload_2_component_1.NewUpload,
                sis_download_component_1.Download,
                sis_upload_component_1.Upload,
                sis_document_component_1.DocumentComponent,
                sis_photo_capture_component_1.PhotoCaptureComponent,
                pipe_module_1.PipeModule
            ],
            providers: [
                idm_authentication_client_js_1.CookieService
            ]
        })
    ], DocumentControlsModule);
    return DocumentControlsModule;
}());
exports.DocumentControlsModule = DocumentControlsModule;
__export(require("./controls/new-upload/sis-upload-2.component"));
__export(require("./controls/download/sis-download.component"));
__export(require("./controls/document/sis-document.component"));
__export(require("./controls/upload/sis-upload.component"));
__export(require("./controls/capture/sis-photo-capture.component"));
//# sourceMappingURL=document-controls.module.js.map